import { useAppSelector } from '@/shared';
import { selectUserRole } from '@/modules/profile';
import {
  Login,
} from '@/pages';
import { AdminDashboard } from './admin-dashboard';
import { OperatorDashboard } from './operator-dashboard';

export const Dashboard = () => {
  const userRole = useAppSelector(selectUserRole);

  switch (userRole) {
    case 'admin':
      return <AdminDashboard />;
    case 'operator':
      return <OperatorDashboard />;
    default:
      return <Login isAuth={false} />;
  }

};
